export default "__VITE_ASSET__DhZgyYWS__"